export default __webpack_public_path__ + "static/media/alt_city.fa839de9.svg";